import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ActiveDatasetProvider } from './contexts/ActiveDatasetContext';
import { AuthProvider } from './contexts/AuthContext';
import { createAppRouter } from './routes';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 2,
    },
  },
});

const root = createRoot(document.getElementById('root')!);
root.render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <ActiveDatasetProvider>
        <RouterProvider router={createAppRouter()} />
      </ActiveDatasetProvider>
    </AuthProvider>
  </QueryClientProvider>
);
